export const SET_USER = "SET_USER";

export const setUserId = (payload) => ({type: SET_USER, payload});